import { createSlice } from '@reduxjs/toolkit'
import { register } from '../../../../../../../../../../helpers/reducerRegistry'
import { convertDataCreditChartRiskScore } from '../../../../../../../../../../helpers/score'
import { TYPE_CHART_RISK } from '../../../creditRiskScore/bottomContent/constant'
import { convertDataChartDistribution } from '../../../creditRiskScore/bottomContent/helper'
import { getDistributionPerformance, getTrendOfScorePerformance } from './thunk'

const initialState = {
  loading: {
    trendOfScore: true,
    distributionScore: true,
  },
  dataChartTrendOfScore: [],
  dataChartDistribution: {
    industry: [],
    region: [],
    year: [],
  },
  typeRadioDynamic: 'industry',
  listScoreCreditDynamic: TYPE_CHART_RISK.map((item) => item.dataKey),
}

const slice = createSlice({
  name: 'companyAnalysis/companyScore/performance/chart',
  initialState: initialState,
  reducers: {
    resetStorePerformanceChart: (state) => {
      Object.keys(initialState).forEach((key) => {
        state[key] = initialState[key]
      })
    },
    changeTypeRadioDynamicPerformance: (state, action) => {
      state.typeRadioDynamic = action.payload
    },
    changeListSelectDynamicPerformance: (state, action) => {
      state.listScoreCreditDynamic = action.payload
    },
  },
  extraReducers: (builder) => {
    //get getTrendOfScore
    builder.addCase(getTrendOfScorePerformance.pending, (state, action) => {
      state.loading.trendOfScore = true
    })
    builder.addCase(getTrendOfScorePerformance.fulfilled, (state, action) => {
      state.dataChartTrendOfScore = convertDataCreditChartRiskScore(
        action.payload,
        action.meta.arg['TimeFrequency'],
      )
      state.loading.trendOfScore = false
    })
    builder.addCase(getTrendOfScorePerformance.rejected, (state, action) => {
      state.dataChartTrendOfScore = initialState['dataChartTrendOfScore']
      state.loading.trendOfScore = action.payload.loading
    })

    //getDistributionScore
    builder.addCase(getDistributionPerformance.pending, (state, action) => {
      state.loading.distributionScore = true
    })
    builder.addCase(getDistributionPerformance.fulfilled, (state, action) => {
      state.dataChartDistribution = convertDataChartDistribution(action.payload)
      state.loading.distributionScore = false
    })
    builder.addCase(getDistributionPerformance.rejected, (state, action) => {
      state.dataChartDistribution = initialState['dataChartDistribution']
      state.loading.distributionScore = action.payload.loading
    })
  },
})
//trend Score Chart
export const selectChartTrendOfScore = (state) =>
  state[slice.name].dataChartTrendOfScore
//distribution Chart
export const selectChartDistribution = (type) => (state) =>
  state[slice.name].dataChartDistribution[type]

//getLoading
export const getLoadingChartCredit = (type) => (state) =>
  type ? state[slice.name].loading[type] : state[slice.name].loading

//select type radio by Dynamic
export const selectTypeRadioDynamicPerformance = (state) =>
  state[slice.name].typeRadioDynamic
export const selectListCheckDynamicPerformance = (state) =>
  state[slice.name].listScoreCreditDynamic

export const {
  resetStorePerformanceChart,
  changeTypeRadioDynamicPerformance,
  changeListSelectDynamicPerformance,
} = slice.actions

register(slice.name, slice.reducer)
